import { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useCampaignStore } from '../stores/campaignStore';
import riachueloLogo from '../assets/riachuelo-logo.svg';

export function CampaignHeader() {
  const navigate = useNavigate();
  const { campaignSlug } = useParams<{ campaignSlug: string }>();
  const { campaign } = useCampaignStore();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (!isMenuOpen) return undefined;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setIsMenuOpen(false);
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isMenuOpen]);

  const handleConsultVoucher = () => {
    setIsMenuOpen(false);
    navigate(`/${campaignSlug}/consultar-voucher`);
  };

  return (
    <>
      <header className="relative z-30 flex items-center justify-center bg-rchlo-green px-5 py-3">
        <button
          type="button"
          onClick={() => setIsMenuOpen(true)}
          className="absolute left-5 text-white"
          aria-label="Abrir menu"
          aria-expanded={isMenuOpen}
        >
          <Menu size={24} />
        </button>
        <img src={riachueloLogo} alt="Riachuelo" className="h-6 w-auto" />
      </header>

      {isMenuOpen && (
        <div className="fixed inset-0 z-40 bg-black/40" role="presentation" onClick={() => setIsMenuOpen(false)}>
          <aside
            className="flex h-full w-[82%] max-w-sm flex-col bg-white shadow-xl"
            aria-label="Menu principal"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="flex items-center justify-between bg-rchlo-green px-5 py-4">
              <img src={riachueloLogo} alt="Riachuelo" className="h-6 w-auto" />
              <button
                type="button"
                onClick={() => setIsMenuOpen(false)}
                className="text-white"
                aria-label="Fechar menu"
              >
                <X size={24} />
              </button>
            </div>

            <nav className="flex flex-col" aria-label="Navegação da campanha">
              <div className="px-5 pt-6 pb-3 text-xs font-bold uppercase tracking-wide text-gray-500">
                Acessos da campanha
              </div>

              <button
                type="button"
                onClick={handleConsultVoucher}
                className="border-b border-gray-100 bg-rchlo-green/5 px-5 py-5 text-left text-base font-bold text-rchlo-green"
              >
                Consultar Voucher
              </button>

              {campaign?.regulationPdfUrl && (
                <a
                  href={campaign.regulationPdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between border-b border-gray-100 px-5 py-5 text-left text-base text-gray-900"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Regulamento
                  <span className="rounded border border-gray-300 px-2 py-0.5 text-xs font-medium text-gray-500">PDF</span>
                </a>
              )}

              {campaign?.faqPdfUrl && (
                <a
                  href={campaign.faqPdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between border-b border-gray-100 px-5 py-5 text-left text-base text-gray-900"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Perguntas frequentes
                  <span className="rounded border border-gray-300 px-2 py-0.5 text-xs font-medium text-gray-500">PDF</span>
                </a>
              )}
            </nav>
          </aside>
        </div>
      )}
    </>
  );
}